module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Gatuadress","flags":["TRACK"],"track":"Street Address"}}